// extracted by mini-css-extract-plugin
export default {"account":"Account_account__ogzVF","account__group":"Account_account__group__sGVgU","account__image":"Account_account__image__sULUN"};